import { apiGet, apiSend } from "./http";

// GET /api/user/decoders — user decoders with their packs.
export const getDecoders = () => apiGet("/api/user/decoders");

// GET /api/user/decoder/{decoderId} — look up a decoder's owner (no auth).
// Returns { result, result_code, user_id, phone }; user_id is null when the
// decoder has no owner yet (caller should send the user to "add decoder").
export const getDecoderOwner = (decoderId) =>
  apiGet(`/api/user/decoder/${decoderId}`);

// PUT /api/user/decoders — attach a decoder to the account.
export async function addDecoder(decoderId) {
  const response = await apiSend("/api/user/decoders", "PUT", {
    decoder_id: decoderId,
  });
  if (!response.ok) throw new Error("Network response was not ok");
}

// DELETE /api/user/decoders — detach a decoder from the account.
export async function deleteDecoder(decoderId) {
  const response = await apiSend("/api/user/decoders", "DELETE", {
    decoder_id: decoderId,
  });
  if (!response.ok) throw new Error("Network response was not ok");
}

// POST /api/user/decoders — update the packs selected for a decoder.
export async function updateDecoderPacks({ decoder_id, packs }) {
  const response = await apiSend("/api/user/decoders", "POST", {
    decoder_id,
    packs,
  });
  if (!response.ok) throw new Error("Network response was not ok");
}
